type ResponsiveColumns = { xl: string; xs: string };

const LEAD_TRACK: ResponsiveColumns = { xl: "100px", xs: "70px" };
const PPD_DIVIDER_TRACK: ResponsiveColumns = { xl: "20px", xs: "4px" };
const PPD_TRACK: ResponsiveColumns = { xl: "300px", xs: "255px" };
const DIVIDER_TRACK: ResponsiveColumns = { xl: "20px", xs: "10px" };
const RATIO_TRACK: ResponsiveColumns = { xl: "180px", xs: "160px" };
const EMPTY_TRACK: ResponsiveColumns = { xl: "0", xs: "0" };
const HPPD_TRACK: ResponsiveColumns = { xl: "auto", xs: "auto" };
const SEPARATED_HPPD_TRACK: ResponsiveColumns = { xl: "minmax(200px, auto)", xs: "minmax(200px, auto)" };
const CENSUS_TRACK: ResponsiveColumns = { xl: "100px", xs: "80px" };
const TRAILING_TRACK: ResponsiveColumns = { xl: "minmax(200px, auto)", xs: "minmax(200px, auto)" };

/**
 * Grid auto-placement fills tracks in DOM order, so the template must list exactly one track per item
 * the stats row renders — a track kept for an item that isn't rendered (even at 0px) is taken by the
 * next item, shifting everything after it into a track sized for something else.
 */
export const getStatsBarGridColumns = ({
	shouldRenderPpdColumn,
	shouldRenderHppdColumn,
	isRatio,
	separateHppd,
}: {
	shouldRenderPpdColumn: boolean;
	shouldRenderHppdColumn: boolean;
	isRatio: boolean;
	separateHppd: boolean;
}): ResponsiveColumns => {
	const tracks: ResponsiveColumns[] = [
		LEAD_TRACK,
		...(shouldRenderPpdColumn ? [PPD_DIVIDER_TRACK, PPD_TRACK] : []),
		...(isRatio || shouldRenderHppdColumn ? [DIVIDER_TRACK] : []),
		isRatio ? RATIO_TRACK : EMPTY_TRACK,
		...(shouldRenderHppdColumn ? [separateHppd ? SEPARATED_HPPD_TRACK : HPPD_TRACK] : []),
		DIVIDER_TRACK,
		CENSUS_TRACK,
		// The last two tracks hold no item; they are the room the secondary row's money breakdown overflows into.
		DIVIDER_TRACK,
		TRAILING_TRACK,
	];
	return {
		xl: tracks.map(({ xl }) => xl).join(" "),
		xs: tracks.map(({ xs }) => xs).join(" "),
	};
};
